export default __webpack_public_path__ + "static/media/nsia.290043c5.png";